<template>
  <div
    ref="myReleaseBlock"
    class="dashboard-block release-list">
    <div class="dashboard-block__heading">
      <h3 class="dashboard-block__title c-with-icon">
        <svg
          class="icon-my_release svg-icon"
          viewBox="0 0 24 24">
          <path
            class="color1"
            d="M20.6,15.8L20,15c1.7-1.7,3-4.5,3-7s-1.3-5.3-3-7l0.6-1C22.7,
            2.1,24,4.9,24,7.9C24,11,22.7,13.7,20.6,15.8zM17,12c0.8-1,
            1-2.6,1-4s-0.2-3-1-4l0.5-1.1c1.3,1.4,2,3.1,2,5c0,1.9-0.8,
            3.7-2,5L17,12z M13.3,10.7L18.1,24h-1.2c-0.9-2.2-3.3-4.1-4.9-4.1c-1.7,
            0-4.1,1.9-4.9,4.1H6l4.7-13.3C9.7,10.2,9,9.2,9,8c0-1.7,1.3-3,3-3s3,1.3,
            3,3C15,9.2,14.3,10.2,13.3,10.7z M9,19h6l-2.9-8c0,0-0.1,0-0.1,0s-0.1,
            0-0.1,0L9,19z M6.5,13c-1.3-1.4-2-3.1-2-5c0-1.9,0.8-3.7,2-5L7,4C6.2,5,
            6,6.6,6,8s0.2,3,1,4L6.5,13z M3.4,15.8C1.3,13.7,0,11,0,7.9c0-3,1.3-5.8,
            3.4-7.9L4,1C2.3,2.7,1,5.5,1,8s1.3,5.3,3,7L3.4,15.8z" />
        </svg>
        マイリリース
      </h3>
    </div>
    <div class="dashboard-block__inner">
      <div class="c-table-caption">横にスクロールしてご覧ください</div>
      <div class="my-release-list">
        <release-table
          title="配信中 / 配信待ち"
          :release-status="releaseStatuses"
          :hide-control2="true"
          :hide-status="true"
          :status-column-title="'未配信ストア'"
          @on-pagination-clicked="scrollTo('myReleaseBlock')">
          <template #statusReplacement="slotProps">
            <a
              v-if="slotProps.release.status === 2"
              class="c-btn-store-add"
              @click.prevent="onAddStoreClicked(slotProps.release)">
              追加する
            </a>
          </template>
          <template v-slot:control1="slotProps">
            <div
              class="c-btn--note"
              @click.prevent="onEditReleaseClicked(slotProps.release)">
            </div>
          </template>
          <template #control2>
            <div class="c-btn--delivery"></div>
          </template>
          <template #empty>
            配信中 / 配信待ちのリリースはありません。
          </template>
        </release-table>
      </div>
    </div>
  </div>
</template>

<script>
import ReleaseTable from '../../Release/ReleaseTable'
import {
  CMAP_RELEASE_STATUS_IN_REVIEW,
  CMAP_RELEASE_STATUS_PUBLISHED,
} from '../../../../consts/status'

export default {
  name: 'DashboardMyRelease',
  components: { ReleaseTable },
  computed: {
    releaseStatuses() {
      return [CMAP_RELEASE_STATUS_IN_REVIEW, CMAP_RELEASE_STATUS_PUBLISHED]
    },
  },
  methods: {
    async onAddStoreClicked(release) {
      const { data } = await window.axios.get(`/api/client/products/${release.id}/release`)
      window.sessionStorage.setItem('album', JSON.stringify(data))
      const routeName = data.type === 'single' ? 'my-release-single-step3' : 'my-release-album-step3'
      this.$router.push({ name: routeName })
    },
    async onEditReleaseClicked(release) {
      const { data } = await window.axios.get(`/api/client/products/${release.id}/release`)
      window.sessionStorage.setItem('album', JSON.stringify(data))
      this.$router.push({ name: 'release-detail' })
    },
    scrollTo(elementName) {
      this.$refs[elementName].scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      })
    },
  },
}
</script>

<style scoped>
.c-btn-store-add {
  color: #ff6c00;
  cursor: pointer;
  text-decoration: underline;
  font-size: 1.4rem;
  white-space: nowrap;
}
.c-btn-store-add:hover {
  text-decoration: none;
}
</style>
